module.exports = __webpack_public_path__ + "media/images/arrows/twisted/light-green-fcb8aeb93c197c85082cad45bc42ee0e.svg";